import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Store } from '@ngxs/store';
import { User } from 'src/app/common/state/user/user.model';
import { UserState } from 'src/app/common/state/user/user.state';

import { PlansService } from '../../../services/plans/plans.service';
import { PlanDetailsItemStateModel } from '../../../state/implementation-plan/implementation-plan.state';
import {
  CreateStatusPlanPayload,
  EmailPreviewPayload,
} from '../../../types/payloads/plan.payload';
import { ModalComponent } from '../../modals/modal/modal.component';

@Component({
  selector: 'app-create-report-modal',
  templateUrl: './create-report-modal.component.html',
  styleUrl: './create-report-modal.component.scss',
  standalone: false,
})
export class CreateReportModalComponent implements OnInit {
  @Input() plan: PlanDetailsItemStateModel;

  @Output() readonly reportCreated = new EventEmitter<boolean>();

  @ViewChild('modal') modal: ModalComponent;

  user: User;

  isLoading = false;

  activeSection: 'form' | 'preview';

  emailRecipients = '';

  emailSubject = '';

  emailBody: string;

  initialHighlightsContent = '';

  highlights: string;

  currentDateTime = new Date().getTime() / 1000;

  errorMessage: string;

  constructor(private plansService: PlansService, private store: Store) {
    this.user = this.store.selectSnapshot(UserState.getUser) as User;
  }

  ngOnInit(): void {
    this.activeSection = 'form';

    const dateNow = new Date();
    const monthName = dateNow
      .toLocaleString('default', { month: 'short' })
      .slice(0, 3);
    if (this.plan) {
      this.emailSubject = `Plan Update for ${
        this.plan.title
      } : ${monthName} ${dateNow.getDate()}, ${dateNow.getFullYear()}`;
    }
  }

  openModal() {
    this.modal.open();
  }

  closeModal() {
    this.resetForm();
    this.modal.close();
  }

  changeSection(sectionName: 'form' | 'preview') {
    if (sectionName === 'form') {
      this.errorMessage = '';
    }
    this.activeSection = sectionName;
  }

  updateHighlights(newNotes: string) {
    this.highlights = newNotes;
  }

  resetForm() {
    this.emailRecipients = '';
    const dateNow = new Date();
    const monthName = dateNow
      .toLocaleString('default', { month: 'short' })
      .slice(0, 3);
    this.emailSubject = `Plan Update for ${
      this.plan.title
    } : ${monthName} ${dateNow.getDate()}, ${dateNow.getFullYear()}`;
    this.highlights = '';
    this.emailBody = '';
    this.activeSection = 'form';
    this.errorMessage = '';
  }

  getEmailPreview() {
    this.isLoading = true;
    const payload: EmailPreviewPayload = {
      highlights: this.highlights,
    };

    this.plansService.previewEmail(this.plan.id, payload).subscribe((res) => {
      if (res.item) {
        this.isLoading = false;
        this.emailBody = res.item;
        this.activeSection = 'preview';
      }
    });
  }

  saveReportData() {
    this.isLoading = true;

    const submitReportPayload: CreateStatusPlanPayload = {
      date: Math.trunc(this.currentDateTime),
      user_id: this.user.id,
      email_subject: this.emailSubject,
      send_to: this.emailRecipients,
      highlights: this.highlights,
      email_body: this.emailBody,
    };

    this.plansService
      .createStatusReport(this.plan.id, submitReportPayload)
      .subscribe({
        error: (err) => {
          this.isLoading = false;
          this.errorMessage = err.error.message;
        },
        complete: () => {
          this.isLoading = false;
          this.activeSection = 'form';
          this.reportCreated.next(true);
          this.closeModal();
        },
      });
  }
}
